import React from 'react';
import { createPortal } from 'react-dom';

// Embeds an external consent form (Jotform) in a pop-up. Portaled to <body> so
// the fixed overlay escapes the slide-wrapper's retained CSS transform.
//
// Deliberately NOT closed by a backdrop click or Escape: a stray tap would throw
// away a half-filled form that lives in a cross-origin iframe we cannot restore.
const SecondaryConsentModal = ({ open, url, title = 'Consent form', onClose }) => {
  if (!open || typeof document === 'undefined') return null;
  return createPortal(
    <div
      className="fixed inset-0 z-[110] flex items-end sm:items-center justify-center bg-black/40 p-0 sm:p-4"
      data-testid="secondary-consent-modal"
    >
      <div
        className="bg-white w-full sm:max-w-2xl sm:rounded-3xl rounded-t-3xl h-[92vh] sm:h-[85vh] flex flex-col overflow-hidden"
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="flex items-start justify-between p-5 border-b border-gray-100 flex-shrink-0">
          <div className="min-w-0 pr-3">
            <h3 className="font-semibold text-gray-900 leading-snug">{title}</h3>
            <p className="text-sm text-gray-500">Please complete and submit this form before closing.</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="text-gray-400 hover:text-gray-600 text-2xl leading-none px-2 flex-shrink-0"
          >
            ×
          </button>
        </div>
        <iframe
          src={url}
          title={title}
          className="flex-1 min-h-0 w-full border-0"
          allow="geolocation; microphone; camera; fullscreen"
          data-testid="secondary-consent-iframe"
        />
        <div className="p-4 border-t border-gray-100 flex-shrink-0">
          <button
            type="button"
            onClick={onClose}
            className="w-full rounded-xl bg-[#2d8a5f] text-white font-semibold py-3 hover:bg-[#256f4d] transition-colors"
            data-testid="secondary-consent-done"
          >
            I've submitted the form
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default SecondaryConsentModal;
